import { memo, type MouseEvent } from "react";

import {
  type CartLine,
  type SelectedOption,
} from "@shopify/hydrogen-react/storefront-api-types";

import { CartProductGiftItem } from "@cart/CartProductGiftItem";
import { CartProductGiftUnassignedItems } from "@cart/CartProductGiftUnassignedItems";

type Props = {
  buttonLabel?: string;
  cartLineUpdating: boolean;
  handleOpenGiftWithPurchaseDrawer: (e: MouseEvent<HTMLElement>) => void;
  handlePreloadProduct: (e: MouseEvent<HTMLElement>) => void;
  linkAriaLabel?: string;
  selectedGiftsWithPurchase: CartLine[] | undefined;
  selectedOptions: Partial<SelectedOption>[] | undefined;
  shippingNote: string | null;
};

const CartProductGiftItemSelectionViewBase = ({
  buttonLabel,
  cartLineUpdating,
  handleOpenGiftWithPurchaseDrawer,
  handlePreloadProduct,
  linkAriaLabel,
  selectedGiftsWithPurchase,
  selectedOptions,
  shippingNote,
}: Props) => {
  return (
    <>
      {selectedGiftsWithPurchase?.map((giftLine, index) => (
        <CartProductGiftItem
          cartLineUpdating={cartLineUpdating}
          giftLine={giftLine}
          key={`${giftLine.id}-${index}`}
          linkAriaLabel={linkAriaLabel}
          selectedOptions={selectedOptions}
          shippingNote={shippingNote}
        />
      ))}
      <CartProductGiftUnassignedItems
        buttonLabel={buttonLabel}
        handleOpenGiftWithPurchaseDrawer={handleOpenGiftWithPurchaseDrawer}
        handlePreloadProduct={handlePreloadProduct}
      />
    </>
  );
};

export const CartProductGiftItemSelectionView = memo(
  CartProductGiftItemSelectionViewBase
);
